<template>
  <div style="position: relative">
    <div class="d-flex justify-content-end mb-4">
      <router-link
        :to="{ name: 'posControle' }"
        class="btn btn-light-primary font-weight-bold"
      >
        <i class="flaticon2-settings mr-1"></i>
        Integração POS Controle
      </router-link>
    </div>

    <FilterFields
      :fields="[
        { type: 'text', label: 'Descrição', field: 'descricao' },
        {
          type: 'select',
          label: 'Status',
          field: 'status',
          options: ['Todos', 'Ativo', 'Inativo'],
        },
      ]"
    />

    <TableApp
      titulo="Terminais Pos"
      acaoBtn="/#/pos/novo"
      textoBtn="Novo"
      api-url="/pos/lista"
      :fields="fields"
      classFilterColumn="descricao"
      ref="pos"
      :perPage="10"
    >
      <template slot="customRow" scope="props">
        <!-- Descrição -->
        <span slot="descricao" v-if="props.field === 'descricao'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div>
                <span class="text-dark-75 font-weight-bold d-block">
                  {{ props.rowData.descricao }}
                  <span
                    class="badge badge-info ml-2"
                    v-if="props.rowData.nuts_pay"
                    >Tef Pay</span
                  >
                </span>
              </div>
            </div>
          </span>
        </span>

        <!-- Modelo -->
        <span slot="modelo" v-if="props.field === 'modelo'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div>
                <span class="text-dark-75 font-weight-bold d-block">
                  {{ modeloPos(props.rowData.modelo) }}
                </span>
              </div>
            </div>
          </span>
        </span>

        <!-- Status -->
        <span v-if="props.field === 'status'">
          <span
            v-if="props.rowData.status"
            class="label label-lg label-inline label-light-success"
            >Ativo</span
          >
          <span v-else class="label label-lg label-inline label-light-danger"
            >Inativo</span
          >
        </span>

        <!-- Ações -->
        <span v-if="props.field === 'actions'">
          <div class="row-actions" style="text-align: right !important">
            <span style="overflow: visible; position: relative; width: 200px">
              <div class="dropdown dropdown-inline">
                <!-- Editar -->
                <router-link
                  class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
                  v-b-tooltip.hover.bottom="'Editar'"
                  :to="{
                    name: 'posEditar',
                    params: {
                      id_configuracao_pos: props.rowData.id_configuracao_pos,
                    },
                  }"
                >
                  <Pencil :size="16" title="Editar" />
                </router-link>

                <!-- Cancelar venda / transação -->
                <button
                  @click="abrirModalCancelarVenda(props.rowData)"
                  class="btn btn-sm btn-warning btn-hover-warning btn-icon mr-2"
                  :title="
                    isNutsPay(props.rowData)
                      ? 'Cancelar transação (Tef Pay)'
                      : 'Cancelar venda'
                  "
                  v-b-tooltip.hover.bottom
                >
                  <Cancel :size="16" />
                </button>

                <!-- Excluir terminal -->
                <button
                  @click="excluir(props.rowData)"
                  class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                  v-b-tooltip.hover.bottom="'Excluir'"
                >
                  <TrashCanIcon :size="16" />
                </button>
              </div>
            </span>
          </div>
        </span>
      </template>
    </TableApp>

    <!-- Modal: Cancelar venda / transação -->
    <b-modal
      id="modal-cancelar-venda"
      ref="modalCancelarVenda"
      :title="
        isNutsPay(linhaSelecionada)
          ? 'Cancelar transação (Tef Pay)'
          : 'Cancelar venda'
      "
      :no-close-on-esc="loadingCancelar"
      :no-close-on-backdrop="loadingCancelar"
      :busy="loadingCancelar"
      hide-footer
    >
      <b-form @submit.prevent="confirmarCancelarVenda">
        <!-- Campo somente se NÃO for Nuts Pay -->
        <b-form-group
          v-if="!isNutsPay(linhaSelecionada)"
          label="Número da venda"
          label-for="numero-venda-input"
          :state="campoNumeroState"
          :invalid-feedback="erroNumeroVenda"
        >
          <b-form-input
            id="numero-venda-input"
            v-model.trim="cancelarVendaForm.numero_venda"
            type="text"
            inputmode="numeric"
            placeholder="Informe o número da venda"
            :disabled="loadingCancelar"
            :state="campoNumeroState"
            @keydown.enter.prevent="confirmarCancelarVenda"
          />
        </b-form-group>

        <!-- Mensagem informativa quando for Nuts Pay -->
        <b-alert v-else show variant="info" class="mb-4">
          Este terminal é <strong>Nuts Pay</strong>. O cancelamento não exige
          número de venda.
        </b-alert>

        <div class="d-flex justify-content-end">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="$refs.modalCancelarVenda.hide()"
            :disabled="loadingCancelar"
          >
            Fechar
          </b-button>
          <b-button
            variant="warning"
            @click="confirmarCancelarVenda"
            :disabled="
              loadingCancelar ||
              (!isNutsPay(linhaSelecionada) && !cancelarVendaForm.numero_venda)
            "
          >
            <b-spinner small v-if="loadingCancelar" class="mr-2" />
            Confirmar cancelamento
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import Cancel from "vue-material-design-icons/Cancel.vue";
import TableApp from "@/components/Table/Table2";
import { SistemaMixin } from "@/modules/Application";
import FilterFields from "@/components/FilterFields";

export default {
  name: "app-nuts-pos",
  mixins: [SistemaMixin],
  components: {
    Pencil,
    TrashCanIcon,
    TableApp,
    FilterFields,
    Cancel,
  },
  data() {
    return {
      fields: [
        {
          label: "Descrição",
          field: "descricao",
          type: "text",
          sortable: true,
          slot: true,
          width: "40%",
        },
        {
          label: "Modelo",
          field: "modelo",
          type: "text",
          sortable: true,
          slot: true,
          width: "20%",
        },
        {
          label: "Status",
          field: "status",
          type: "text",
          sortable: false,
          slot: true,
          width: "20%",
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "20%",
        },
      ],
      loadingCancelar: false,
      linhaSelecionada: null,
      cancelarVendaForm: { numero_venda: "" },
      erroNumeroVenda: null,
    };
  },
  methods: {
    // Nuts Pay = boolean presente no objeto (row.nuts_pay)
    isNutsPay(row) {
      return !!(row && row.nuts_pay);
    },

    abrirModalCancelarVenda(row) {
      this.linhaSelecionada = row;
      this.cancelarVendaForm.numero_venda = "";
      this.erroNumeroVenda = null;
      this.$refs.modalCancelarVenda.show();
    },

    async confirmarCancelarVenda() {
      const ehNutsPay = this.isNutsPay(this.linhaSelecionada);

      // validação somente quando NÃO for Nuts Pay
      if (!ehNutsPay) {
        const numero = (this.cancelarVendaForm.numero_venda || "")
          .toString()
          .trim();
        if (!numero) {
          this.erroNumeroVenda = "Informe o número da venda.";
          return;
        }
        if (!/^\d+$/.test(numero)) {
          this.erroNumeroVenda = "Use apenas números no campo Número da venda.";
          return;
        }
        this.erroNumeroVenda = null;
      }

      try {
        this.loadingCancelar = true;

        // payload sem numero_venda quando for Nuts Pay
        const payload = {
          id_configuracao_pos: this.linhaSelecionada.id_configuracao_pos,
          ...(ehNutsPay
            ? {}
            : { numero_venda: this.cancelarVendaForm.numero_venda }),
        };

        // endpoint único (ajuste se houver rota específica para Nuts Pay)
        await this.$http.post("/pos/cancelar-venda", payload);

        this.$refs.modalCancelarVenda.hide();
        this.$toast.success("Cancelamento realizado com sucesso!");
        this.$refs.pos.refresh();
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          "Não foi possível concluir o cancelamento.";
        this.$toast.error(msg);
      } finally {
        this.loadingCancelar = false;
      }
    },

    excluir(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir o terminal " + data.descricao + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/pos/delete", {
              id_configuracao_pos: data.id_configuracao_pos,
            });
            this.$refs.pos.refresh();
            this.$toast.success("Terminal excluído!");
          }
        });
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked", "currentUser"]),
    config() {
      return this.layoutConfig();
    },
    // estado do input (quando existir)
    campoNumeroState() {
      if (this.isNutsPay(this.linhaSelecionada)) return null;
      if (this.cancelarVendaForm.numero_venda === "") return null;
      return this.erroNumeroVenda ? false : true;
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
